"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberWithDecimalsRegex = /^\d{0,99}(\,)?(\d{1,2})?$/;
exports.emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
exports.numericalFourDigitsRegex = /^[0-9]{4}$/;
exports.numericalTenDigitsRegex = /^[0-9]{10}$/;
exports.lettersAndSpacesRegex = /^[ñÑa-zA-ZÀ-ÿ\u00f1\u00d1\u0027]+(\s*[ñÑa-zA-ZÀ-ÿ\u00f1\u00d1\u0027]*)*[ñÑa-zA-ZÀ-ÿ\u00f1\u00d1\u0027\s]+$/;
exports.whitespacesRegex = /\s+/g;
exports.doubleWhitespacesRegex = /\s\s/g;
exports.upperCaseLetters = /[A-ZÑ]+/;
exports.lowerCaseLetters = /[a-zñ]+/;
exports.letters = /[A-Za-zñÑ]+/;
exports.numbers = /[0-9]+/;
exports.symbols = /[!@#$%^&]+/;
exports.passwordWithMultipleGroups = [exports.upperCaseLetters, exports.lowerCaseLetters, exports.numbers, exports.symbols];
exports.atLeastOneLowerCaseRegex = /(?=.*[a-zñ])/;
exports.atLeastOneUpperCaseRegex = /(?=.*[A-ZÑ])/;
exports.atLeastOneNumberRegex = /(?=.*\d)/;
exports.maestroPatternsRegex = /^(601782|508143|501081|501080|501051|501059|557909|501066|588729|501075|501062|501060|501057|501056|501055|501053|501043|501041|501038|501028|501023|501021|501020|501018|501016)/;
exports.maestroFirstPatternRegex = /^(501051|501059|557909|501066|588729|501075|501062|501060|501057|501056|501055|501053|501043|501041|501038|501028|501023|501021|501020|501018|501016)/;
exports.maestroSecondPatternRegex = /^(601782|508143|501081|501080)/;
exports.hipercardPatternsRegex = /^(637599|637609|637612|384100|384140|384160|606282|637095|637568)/;
exports.visaElectronRegex = /(^(?!450843)4(026|17500|405|508|844|91[37]))/;
exports.cabalRegex = /^((627170)|(589657)|(603522)|(604((20[1-9])|(2[1-9][0-9])|(3[0-9]{2})|(400))))/;
exports.creditCardsDefaultFormat = /(\d{1,4})/g;
var REGEX = {
  numberWithDecimalsRegex: exports.numberWithDecimalsRegex,
  emailRegex: exports.emailRegex,
  numericalFourDigitsRegex: exports.numericalFourDigitsRegex,
  numericalTenDigitsRegex: exports.numericalTenDigitsRegex,
  lettersAndSpacesRegex: exports.lettersAndSpacesRegex,
  whitespacesRegex: exports.whitespacesRegex,
  doubleWhitespacesRegex: exports.doubleWhitespacesRegex,
  upperCaseLetters: exports.upperCaseLetters,
  lowerCaseLetters: exports.lowerCaseLetters,
  numbers: exports.numbers,
  symbols: exports.symbols,
  passwordWithMultipleGroups: exports.passwordWithMultipleGroups,
  atLeastOneLowerCaseRegex: exports.atLeastOneLowerCaseRegex,
  atLeastOneUpperCaseRegex: exports.atLeastOneUpperCaseRegex,
  atLeastOneNumberRegex: exports.atLeastOneNumberRegex,
  maestroFirstPatternRegex: exports.maestroFirstPatternRegex,
  maestroSecondPatternRegex: exports.maestroSecondPatternRegex,
  maestroPatternsRegex: exports.maestroPatternsRegex,
  hipercardPatternsRegex: exports.hipercardPatternsRegex,
  letters: exports.letters,
  visaElectronRegex: exports.visaElectronRegex,
  cabalRegex: exports.cabalRegex
};
exports.default = REGEX;